export const injectReduxMiddleware = () => {};
